<template>
  <div>
    <v-container>
      <h1>{{title}}</h1>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.actions="{item}">
          <v-btn
            icon
            text
            :to="
              `/onboarding-sched-approval/${item.transactionNo}`
            "
          >
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import { headers } from "./variables"
export default {
  metaInfo: {
    title: "Onboarding Schedule Approval Incharge",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  data: () => ({
    title: "Onboarding Schedule Approval Incharge",
    items: [],
    headers
  }),
  methods: {
    getForApproval() {
      this.$axios.get(`/api/onboardingSched/approval`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message)
        })
    }
  },
  created() {
    this.getForApproval();
  }
}
</script>